import { PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private percentPipe: PercentPipe
  ) { }

  transform(value: number, decimals = 0): any {
    const currentLang = this.translateService.currentLang;

    return this.percentPipe.transform(value, `.${ decimals }`, currentLang);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/pipes/percentage.pipe.ts